import { FILTERED_LISTING_MODULE_TYPE } from '@/app/lib/analytics/constants'

/**
 * Valores de analítica de los módulos CMS generales montados por
 * `ModulesAdminRenderer` (Home, categoría, microsites…). Un único sitio para que
 * los módulos no hardcodeen literales y Analítica pueda sustituir los
 * provisionales sin tocarlos.
 *
 * Criterio (`00_Instrucciones.md`: módulos transversales): cada módulo toma el
 * `module_type` de su módulo equivalente en `components-fingerprint/`. Los
 * `module_name`/`item_list_name` NO están en la guía para estos módulos (los CSV
 * solo dan los de Home/PDP): se definen aquí y quedan ⚠️ PROVISIONALES, pendientes
 * de confirmar con Analítica. El `item_list_id` NO está aquí: se deriva del
 * `page_type` vigente (`<page_type>_<module_type>`).
 */

/* ── Listados de producto (view_item_list / select_item / add_to_cart) ────── */

/** `Grid destacados.csv` → `product_list_featured`; `module_name`/`item_list_name`
 * literales de esa ficha (`representaciones_destacadas` / `eventos_destacados`). */
export const FEATURED_MODULE_TYPE = 'product_list_featured'
export const FEATURED_MODULE_NAME = 'representaciones_destacadas'
export const FEATURED_LIST_NAME = 'eventos_destacados'

/** ⚠️ PROVISIONAL: `ContenidoProducto` (banner de un único producto destacado) no tiene
 * CSV propio; reutiliza `FEATURED_MODULE_TYPE` y define sus `module_name`/`item_list_name`. */
export const FEATURED_PRODUCT_MODULE_NAME = 'producto_destacado'
export const FEATURED_PRODUCT_LIST_NAME = 'producto_destacado'

/** `Grid Cards.csv` → `product_list_localized` (grid de cards de producto). */
export const GRID_CARDS_MODULE_TYPE = 'product_list_localized'

export const BUY_BUTTON_MODULE_NAME = 'productos_boton_compra'
export const BUY_BUTTON_LIST_NAME = 'productos_con_boton_compra'

export const THREE_COLUMNS_MODULE_NAME = 'productos_3_columnas'
export const THREE_COLUMNS_LIST_NAME = 'productos_3_columnas'

export const PRODUCTS_CAROUSEL_MODULE_NAME = 'productos_recomendados'
export const PRODUCTS_CAROUSEL_LIST_NAME = 'productos_recomendados'

export const WEEKEND_MODULE_NAME = 'productos_por_periodo'
export const WEEKEND_LIST_NAME = 'productos_por_periodo'
/** `Listado filtrado.csv` → listado con filtros (chips de periodo/provincia). */
export const WEEKEND_MODULE_TYPE = FILTERED_LISTING_MODULE_TYPE

export const AGENDA_MODULE_NAME = 'agenda_modulo'
export const AGENDA_LIST_NAME = 'agenda_modulo'
export const AGENDA_MODULE_TYPE = FILTERED_LISTING_MODULE_TYPE

/* ── Promoción / PromociónDoble (view_promotion / select_promotion) ───────── */

/** ⚠️ PROVISIONAL: la guía no fija `module_name`/`module_type` para banners
 * promocionales (solo `carousel`/`hero_carousel` para el hero). Mismos valores
 * que el banner de canal, por ser el mismo componente (`PromoBanner`). */
export const PROMO_MODULE_NAME = 'banner_promocional'
export const PROMO_MODULE_TYPE = 'promo_banner'

/** `analytic-e-commerce.md`: `banner_simple | banner_doble_portada`. ⚠️ PROVISIONAL (mapeo). */
export const PROMO_CREATIVE_SINGLE = 'banner_simple'
export const PROMO_CREATIVE_DOUBLE = 'banner_doble_portada'

/** `creative_slot`: `cover` la primera y `slide_N` las siguientes. */
export function buildPromoCreativeSlot(index: number): string {
  return index === 0 ? 'cover' : `slide_${index + 1}`
}
